import React from 'react';
import { X, Plus, Minus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const CartDialog = ({ isOpen, onClose }) => {
  const { cartItems, updateQuantity, removeFromCart, getCartTotal, getCartCount } = useCart();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleCheckout = () => {
    onClose();
    navigate('/checkout');
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />

      {/* Cart Sidebar */}
      <div
        className="fixed right-0 top-0 h-full w-full md:w-96 z-50 shadow-xl transform transition-transform"
        style={{ backgroundColor: '#f7f5f2' }}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b" style={{ borderColor: '#e5d5c0' }}>
            <h2 className="text-2xl font-bold" style={{ color: '#4a2c1a' }}>
              Your Cart ({getCartCount()})
            </h2>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="h-6 w-6" style={{ color: '#4a2c1a' }} />
            </Button>
          </div>

          {/* Cart Items */}
          <div className="flex-1 overflow-y-auto p-6">
            {cartItems.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-lg" style={{ color: '#736c64' }}>
                  Your cart is empty
                </p>
              </div>
            ) : (
              <div className="space-y-4">
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    className="flex gap-4 p-4 rounded-lg border"
                    style={{ backgroundColor: 'white', borderColor: '#e5d5c0' }}
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-20 h-20 object-cover rounded"
                    />
                    <div className="flex-1">
                      <h3 className="font-semibold" style={{ color: '#4a2c1a' }}>
                        {item.name}
                      </h3>
                      <p className="text-sm" style={{ color: '#736c64' }}>
                        ${item.price.toFixed(2)}
                      </p>
                      <div className="flex items-center gap-2 mt-2">
                        <Button
                          variant="outline"
                          size="icon"
                          className="h-8 w-8"
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                        >
                          <Minus className="h-4 w-4" />
                        </Button>
                        <span className="w-8 text-center font-medium" style={{ color: '#4a2c1a' }}>
                          {item.quantity}
                        </span>
                        <Button
                          variant="outline"
                          size="icon"
                          className="h-8 w-8"
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                        >
                          <Plus className="h-4 w-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="icon"
                          className="h-8 w-8 ml-auto"
                          onClick={() => removeFromCart(item.id)}
                        >
                          <Trash2 className="h-4 w-4" style={{ color: '#dc2626' }} />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          {cartItems.length > 0 && (
            <div className="border-t p-6" style={{ borderColor: '#e5d5c0', backgroundColor: 'white' }}>
              <div className="flex items-center justify-between mb-4">
                <span className="text-lg font-semibold" style={{ color: '#4a2c1a' }}>
                  Total:
                </span>
                <span className="text-2xl font-bold" style={{ color: '#FF8C19' }}>
                  ${getCartTotal().toFixed(2)}
                </span>
              </div>
              <Button
                className="w-full text-white font-semibold py-6 text-lg hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#FF8C19' }}
                onClick={handleCheckout}
              >
                Proceed to Checkout
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CartDialog;